import axios from 'axios'
import env from 'configuration'
import { toast } from 'react-toastify'
import { removeAuth } from './auth-helper'

// One redirect even when several requests fail with 401 together.
let sessionExpired = false

// The API reports failures in two shapes: services return { success: false, message },
// while middleware and guards send { error } - subscription expiry, auth and permission
// checks all use the latter. Reading only `message` turned every one of those into a
// generic "Something went wrong".
//
// Validation failures send BOTH: a vague message ("Invalid or missing field") plus the
// specific reason in `error` ("\"deal.deduct_on_request\" is not allowed"), so combine
// them rather than showing only the vague half.
const serverMessage = (error) => {
  const data = error?.response?.data
  if (!data) return 'Something went wrong'
  // A proxy or a 404 can return an HTML page; never dump that into a toast.
  if (typeof data === 'string')
    return /^\s*</.test(data) ? 'Something went wrong' : data

  const str = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null)
  const message = str(data.message)
  const detail = str(data.error)

  if (message && detail && detail !== message) return `${message}: ${detail}`
  return message || detail || 'Something went wrong'
}

const BASE_URL = `${env.API_URL}/v1`

export default async function Api(path, method, option) {
  const url = BASE_URL + path
  let config = {}
  if (option?.headers) config.headers = option.headers
  
  // For methods that send data in body (POST, PUT, PATCH), use option as data if no payload specified
  const data = ['post', 'put', 'patch'].includes(method.toLowerCase()) 
    ? (option?.payload || option) 
    : undefined
    
  return axios[method](url, data, config)
    .then((response) => {
      if (option?.notify) toast.success(response.data?.message)

      return { response: response.data }
    })
    .catch((error) => {
      if (
        typeof error?.message == 'string' &&
        error?.message?.includes('401')
      ) {
        // Signed-in dashboard pages go back to the login screen; public customer pages
        // (join, check-in, recognition, passes) never needed a session, so they stay.
        const path = window.location.pathname
        const isPublic = /^\/(login|join|checkin|recognise|registration|customer|tool)\b/.test(path)
        if (!isPublic && !sessionExpired) {
          sessionExpired = true
          toast.error('Your session is expired, login again to continue')
          removeAuth()
          setTimeout(() => window.location.assign('/login'), 1500)
        }
      }
      if (option?.notify) toast.error(serverMessage(error))
      return { error: error.response ? error.response.data : null }
    })
}
